import Icon from '../components/Icon.vue'

Icon.register({
  'power-off': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248-136.5 0.3-248.3-111-248.5-247.6-0.1-83.3 40.9-157.1 103.8-202.2 11.7-8.3 28-4.8 35 7.7l15.8 28.1c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-0.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-0.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-240c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/power-off.js
// module id = 1660
// module chunks = 0